var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    WidgetResultBrickModel: function(opts) {
        var form = opts.form;
        var container = form.find('.collection-container');

    	Operator.Layout.setupCollections(form, function(){
			 container.find('.panel').each(function () {
	    		var thisPanel = $(this);
	    		bindPanelEvents(container, thisPanel);
	    	});
    	});

        container.find('.panel').each(function () {
    		var thisPanel = $(this);
    		bindPanelEvents(container, thisPanel);
    	});

    	function bindPanelEvents(container, panel) {

	       	var titleType = panel.find('[data-role="title-type"]');
            var titleName = panel.find('[data-role="title-name"]');

	        panel.find('[data-action="delete-row"]').click(function (e) {
	        	panel.remove();
	        	resetElementIndexes($('.collection-container'));
	        });

	        panel.find('select').each(function () {
	        	var thisSelect = $(this);
	        	titleType.text(changeTitleType(thisSelect));

	        	thisSelect.change(function () {
                    titleType.text(changeTitleType(thisSelect));
	        	});
	        });

	        panel.find('input[type="text"]').each(function () {
	        	var thisText = $(this);

	        	titleName.text(thisText.val());

	        	thisText.change(function () {
                    titleName.text(thisText.val());
	        	});
	        });
    	}

        function resetElementIndexes(container){
    		container.find('.panel').each(function (i, panel) {
    			panel = $(panel);
    			
    			var idPatt = /_[0-9]+__/gi;
                var namePatt = /\[[0-9]+]/gi;

    			var inputs = panel.find('[data-role="prop-name"],[data-role="prop-type"]');
    			
    			inputs.each(function () {
    				input = $(this);

    				input.attr('name', input.attr('name').replace(namePatt, '[' + i + ']'));
    				input.attr('id', input.attr('id').replace(idPatt, '_' + i + '__'));
    			});
    		});
    	}


    	function changeTitleType(select) {

    		var selectedOption = _.find(select.find('option'), function (option) {
        		return $(option).val() == select.val();
        	});

        	return $(selectedOption).text();
    	}
    }
});